import InfoSection from '../components/info_section';
import ScrollButton from '../components/scroll_button';
import { migratorList, stepMigrator, relatedServices } from '../constants/migrator';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styles from '../styles/migrator.module.scss';
import ContactUsModal from '../components/contactUsModal';
import RelatedServices from '../components/relatedServices';
import Image from 'next/image';

export default function Migrator() {
  const router = useRouter();
  const { t } = useTranslation('migrator');

  const stepMigratorList = stepMigrator.map((item, index) => (
    <li key={index} dangerouslySetInnerHTML={{ __html: t(`howItWorks.workList.${item}`, { interpolation: { escapeValue: false } }) }} />
  ));

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
      <InfoSection title='Migrator' description='migratorDescription' documentationLink='https://help.icdc.io/migrator/' lang={router.locale} />

      <section className={styles.introduction}>
        <div className={styles.introduction__content}>
          <div>
            <h2>{t('introduction.title')}</h2>
            <p>{t('introduction.description')}</p>
          </div>
          <div>
            <h3>{t('canBeMigrated.title')}</h3>
            <p dangerouslySetInnerHTML={{__html: t('canBeMigrated.description', { interpolation: { escapeValue: false }})}} />
          </div>
        </div>
        <Image src='/migrator.webp' alt="Migrator" width={841} height={418} unoptimized loading='lazy' />
      </section>

      <section className={styles.steps}>
        <div className={styles.steps__content}>
          <h2>{t('howItWorks.title')}</h2>
          <ul>
            {stepMigratorList}
          </ul>
        </div>
      </section>

      <section className={styles.assessment}>
        <div>
          <h2>{t('assessment.title')}</h2>
          <p>{t('assessment.description')}</p>
          <br />
          <p>
            <ContactUsModal isText />
            {t('assessment.descriptionContinuation')}
          </p>
        </div>
      </section>

      <section className={styles.benefits}>
        <h2>{t('benefits.title')}</h2>
        <div className={styles.benefits__list}>
          {
            migratorList.map((features, index) => <div key={index}>
              <h3>{t(features.subtitle)}</h3>
              <p dangerouslySetInnerHTML={{__html: t(features.subdescription, { interpolation: { escapeValue: false }})}} />
            </div>)
          }
        </div>
      </section>

      <RelatedServices services={relatedServices} />
    </Layout>
  )
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['migrator', 'common']),
  },
});
